"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HALF_LEFT_SPACE = exports.POSITION_RIGHT = exports.POSITION_LEFT = exports.POSITION_RIGHT_CENTER = exports.POSITION_LEFT_CENTER = exports.POSITION_BOTTOM_RIGHT = exports.POSITION_BOTTOM_CENTER = exports.POSITION_BOTTOM_LEFT = exports.POSITION_TOP_RIGHT = exports.POSITION_TOP_CENTER = exports.POSITION_TOP_LEFT = exports.MESSAGE_DANGER = exports.MESSAGE_WARNING = exports.MESSAGE_INFO = exports.MESSAGE_SUCCESS = exports.DANGER = exports.SUCCESS = exports.SECONDARY = exports.PRIMARY = exports.SIZE_MASSIVE = exports.SIZE_HUGE = exports.SIZE_BIG = exports.SIZE_XLARGE = exports.SIZE_LARGE = exports.SIZE_MEDIUM = exports.SIZE_SMALL = exports.SIZE_TINY = exports.SIZE_MINI = void 0;
var SIZE_MINI = 'co--mini';
exports.SIZE_MINI = SIZE_MINI;
var SIZE_TINY = 'co--tiny';
exports.SIZE_TINY = SIZE_TINY;
var SIZE_SMALL = 'co--small';
exports.SIZE_SMALL = SIZE_SMALL;
var SIZE_MEDIUM = 'co--medium';
exports.SIZE_MEDIUM = SIZE_MEDIUM;
var SIZE_LARGE = 'co--large';
exports.SIZE_LARGE = SIZE_LARGE;
var SIZE_XLARGE = 'co--xlarge';
exports.SIZE_XLARGE = SIZE_XLARGE;
var SIZE_BIG = 'co--big';
exports.SIZE_BIG = SIZE_BIG;
var SIZE_HUGE = 'co--huge';
exports.SIZE_HUGE = SIZE_HUGE;
var SIZE_MASSIVE = 'co--massive';
exports.SIZE_MASSIVE = SIZE_MASSIVE;
var PRIMARY = 'primary';
exports.PRIMARY = PRIMARY;
var SECONDARY = 'secondary';
exports.SECONDARY = SECONDARY;
var SUCCESS = 'success';
exports.SUCCESS = SUCCESS;
var DANGER = 'danger';
exports.DANGER = DANGER;
var MESSAGE_SUCCESS = 'success';
exports.MESSAGE_SUCCESS = MESSAGE_SUCCESS;
var MESSAGE_INFO = 'info';
exports.MESSAGE_INFO = MESSAGE_INFO;
var MESSAGE_WARNING = 'warning';
exports.MESSAGE_WARNING = MESSAGE_WARNING;
var MESSAGE_DANGER = 'danger';
exports.MESSAGE_DANGER = MESSAGE_DANGER;
var POSITION_TOP_LEFT = 'top left';
exports.POSITION_TOP_LEFT = POSITION_TOP_LEFT;
var POSITION_TOP_CENTER = 'top center';
exports.POSITION_TOP_CENTER = POSITION_TOP_CENTER;
var POSITION_TOP_RIGHT = 'top right';
exports.POSITION_TOP_RIGHT = POSITION_TOP_RIGHT;
var POSITION_BOTTOM_LEFT = 'bottom left';
exports.POSITION_BOTTOM_LEFT = POSITION_BOTTOM_LEFT;
var POSITION_BOTTOM_CENTER = 'bottom center';
exports.POSITION_BOTTOM_CENTER = POSITION_BOTTOM_CENTER;
var POSITION_BOTTOM_RIGHT = 'bottom right';
exports.POSITION_BOTTOM_RIGHT = POSITION_BOTTOM_RIGHT;
var POSITION_LEFT_CENTER = 'left center';
exports.POSITION_LEFT_CENTER = POSITION_LEFT_CENTER;
var POSITION_RIGHT_CENTER = 'right center';
exports.POSITION_RIGHT_CENTER = POSITION_RIGHT_CENTER;
var POSITION_LEFT = 'left';
exports.POSITION_LEFT = POSITION_LEFT;
var POSITION_RIGHT = 'right';
exports.POSITION_RIGHT = POSITION_RIGHT;
var HALF_LEFT_SPACE = 'half-left-space';
exports.HALF_LEFT_SPACE = HALF_LEFT_SPACE;